// extracted by css-extract-rspack-plugin
export default {"cls1":"PostPrompt-cls1_hPX","cls2":"PostPrompt-cls2_Dwj PostPrompt-cls1_hPX"};